import React from 'react'
import "./FilmProjectPage.scss"
import { useParams } from 'react-router-dom'
import { projectData } from '../../contents/projectData';
import Linkify from 'linkify-react';
import { Button } from '../../components/Button/Button';
import ReactPlayer from 'react-player/lazy';
import { Link } from 'react-router-dom';


export const FilmProjectPage = () => {
    const {projectId} = useParams();
    const project = projectData[projectId];
    if (!project) {
        return <div>Project not found</div>; // Handle non-existent project
    }
    return (
        <div className='page-content film-project-page'>
            <h2 className='mt-3'>{project.title}</h2>
            <h3 className='mt-2'>{project.role}</h3>
            <h4 className='mt-1'>{project.lengthAndYear}</h4>
            {project.videoLink && 
                <div className='mt-4 video-embed-wrapper'>
                    <ReactPlayer 
                        className="react-player"
                        controls={true} 
                        width="100%" 
                        height="100%" 
                        url={project.videoLink} />
                </div>
            }
            <Linkify>
                <p className='mt-8 mb-4'>{project.intro}</p>
            </Linkify>
            {/* Place holder for the video */}
            <Link to={`../../journey/${project.storyUrl}`}>
                <Button text="Read BTS Stories Here"></Button>
            </Link>
        </div>
    )
}
